import { render, staticRenderFns } from "./FoundingTeam.vue?vue&type=template&id=55f912ba"
import script from "./FoundingTeam.vue?vue&type=script&lang=js"
export * from "./FoundingTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports